export const MESSAGE_TYPES = [
    {value: 'message', label: 'Message'},
    {value: 'medication-change', label: 'Medication change'},
    {value: 'incident-report', label: 'Incident report'},
];
